﻿export interface IRatingTiersEditability {
    property: boolean;
    liability: boolean;
}

export class RatingTiersEditability implements IRatingTiersEditability {
    property: boolean;
    liability: boolean;
}